<template>
  <div style="display: inline-block; margin-bottom: 20px;">
    <span
      v-if="value.texto == null"
      :id="`toMatch${index}${dataId}`"
      draggable="true"
      @dragstart="drag($event)"
      @dragover.prevent
      @drop="drop($event)"
      :class="`dv-line elementosToMatch ${dataId}`"
    ></span>
    <span
      v-if="value.texto !== null"
      style="width: auto; height:auto; display: inline-block; margin-left:7px;"
    >{{value.texto}}</span>
  </div>
</template>

<script>
export default {
  name: "drag-drop-div",
  data() {
    return {
      textoOk: ""
    };
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    value: {
      type: Object
    },
    dataId: {
      type: String,
      default: ""
    }
  },
  created() {
    console.log("dataId::", this.dataId);
  },
  methods: {
    drag(event) {
      //console.log(event);
      event.dataTransfer.setData("id", event.target.id);
      event.dataTransfer.setData("value", event.target.innerHTML);
    },
    drop(ev) {
      console.log("drop", ev);
      let idOrigen = ev.dataTransfer.getData("id");
      console.log("id origen", idOrigen);
      let dataOrigen = ev.dataTransfer.getData("value");
      let elementoOrigen = document.getElementById(idOrigen);
      let idDestino = ev.target.id;
      let elementoDestino = document.getElementById(idDestino);
      let dataDestino = elementoDestino.innerHTML;
      elementoOrigen.innerHTML = dataDestino;
      elementoDestino.innerHTML = dataOrigen;
      if (elementoOrigen.classList.contains("elemento-origen")) {
        if (elementoOrigen.innerHTML == "") {
          elementoOrigen.classList.add("ele-display-none");
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dv-line {
  width: 200px;
  height: 30px;
  background-color: transparent;
  border: none;
  border-bottom: 3px solid #ddd;
  display: inline-block;
  text-align: center;
  margin-left: 10px;
  font-weight: bold;
  cursor: grab;
}
</style>